import { useAxiosInstances } from "../../axios-instance";

import { useAppSelector } from "../../../presentation/hooks/store-hooks";

export const useGeolocalizacaoApi = () => {
  const { axiosInstance } = useAxiosInstances();
  const { auth } = useAppSelector((state) => state);
  const { currentUser } = useAppSelector((state) => state.user);

  const getGeolocalizacaoBySearchTermApi = async (data: {
    searchTerm: string;
  }) => {
    try {
      // const result = await axiosInstance.get(`https://nominatim.openstreetmap.org/search?q=${data.searchTerm}&format=json&polygon_geojson=1&addressdetails=1`)
      
      const result = await axiosInstance.get(
        `/geo-veles/geolocalizacao/${data.searchTerm}, ${currentUser?.IdUsuario}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`, // 🔥 Replace with the actual token
          },
        }
      );
      if (result.data.geolocalizacoes.geolocalizacoes.length > 0) {
        return result.data.geolocalizacoes;
      } else {
        throw new Error(
          "Nenhum resultado de geolocalização encontrado para o termo informado"
        );
      }
    } catch (error) {
      throw error;
    }
  };

  const getGeolocalizacaoDetailsApi = async (data: {
    osmType: string;
    osmId: number;
    class: string;
  }) => {
    try {
      // const result = await axiosInstance.get(`https://nominatim.openstreetmap.org/details.php?osmtype=${data.osmType}&osmid=${data.osmId}&class=${data.class}&addressdetails=1&hierarchy=0&group_hierarchy=1&format=json`)

      const result = await axiosInstance.get(
        "/geo-veles/geolocalizacao/details/",
        {
          params: {
            IdUsuario: currentUser?.IdUsuario,
            osmType: data.osmType,
            osmId: data.osmId,
            class: data.class,
          },
          headers: {
            Authorization: `Bearer ${auth.token}`, // 🔥 Replace with the actual token
          },
        }
      );
      if (result) {
        return {
          geolocalizacao: result.data,
        };
      }
    } catch (error) {
      throw error;
    }
  };

  const getGeolocalizacaoByPlaceIdApi = async (data: { placeId: number }) => {
    try {
      // const result = await axiosInstance.get(`https://nominatim.openstreetmap.org/details.php?place_id=${data.placeId}&addressdetails=1&hierarchy=0&group_hierarchy=1&format=json`)

      const result = await axiosInstance.get(
        `/geo-veles/geolocalizacao/placeId/${data.placeId}, ${currentUser?.IdUsuario}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`, // 🔥 Replace with the actual token
          },
        }
      );
      if (result) {
        return {
          geolocalizacao: result.data,
        };
      }
    } catch (error) {
      throw error;
    }
  };

  const getGeolocalizacaoByLatLonApi = async (data: {
    lat: number;
    lon: number;
  }) => {
    try {
      //const result = await axiosInstance.get(`https://nominatim.openstreetmap.org/reverse?format=geojson&lat=${data.lat}&lon=${data.lon}&addressdetails=1&hierarchy=0&group_hierarchy=1&format=json`)

      const result = await axiosInstance.get(
        `/geo-veles/geolocalizacao/latLon/${data.lat}, ${data.lon}, ${currentUser?.IdUsuario}`,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`, // 🔥 Replace with the actual token
          },
        }
      );
      if (result) {
        return {
          geolocalizacao: result.data.geolocalizacoes.geolocalizacao[0],
        };
      } else {
        throw new Error("Erro ao buscar localização");
      }
    } catch (error) {
      throw error;
    }
  };

  return {
    getGeolocalizacaoBySearchTermApi,
    getGeolocalizacaoDetailsApi,
    getGeolocalizacaoByPlaceIdApi,
    getGeolocalizacaoByLatLonApi,
  };
};
